/**
 * Run one self-contained pass of helper Python (the editor's formatter, syntax
 * validator, import analyzer, ...) in a fresh namespace and return the value of
 * its last expression.
 *
 * Step code executes in Pyodide's shared `__main__` namespace. Helper code run
 * there with a bare runPython() binds its imports and functions into that
 * namespace, so step code could use `json` or `ast` without importing them
 * (and then fail headless on enoch) or break a helper by rebinding a name.
 * A scratch namespace keeps each pass private (EHQ-117).
 */
export function runPythonIsolated(python: any, code: string): any {
  const scratch = python.toPy({});
  try {
    return python.runPython(code, { globals: scratch });
  } finally {
    scratch?.destroy?.();
  }
}
